import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

const CreateModal = ({ onClose }) => {
  const navigate = useNavigate();

  const options = [
    {
      icon: '+',
      gradient: 'linear-gradient(135deg, #52B8AC 0%, #3A8A80 100%)',
      title: 'Post',
      action: () => { onClose(); navigate('/create-post'); }
    },
    {
      icon: '\u26A1',
      gradient: 'linear-gradient(135deg, #FFBB86 0%, #FFA26B 100%)',
      title: 'Action',
      action: () => { onClose(); navigate('/create-challenge'); }
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
      data-testid="create-modal-overlay"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0, 0, 0, 0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 20,
      }}
    >
      <motion.div
        initial={{ scale: 0.92, opacity: 0, y: 12 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.92, opacity: 0, y: 12 }}
        transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
        onClick={(e) => e.stopPropagation()}
        data-testid="create-modal"
        style={{
          background: '#FFFFFF',
          borderRadius: 22,
          padding: '24px 24px 20px',
          maxWidth: 340,
          width: '100%',
          boxShadow: '0 16px 48px rgba(0, 0, 0, 0.18)',
        }}
      >
        {/* Header */}
        <div style={{ 
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',textAlign: 'center',
          marginBottom: 20,
        }}>
          <h3 data-testid="create-modal-title" style={{
            fontSize: 16, fontWeight: 700, color: '#1F2937',
            margin: 0, lineHeight: 1.25, letterSpacing: '-0.3px',
          }}>
            Create an Impact by Creating
          </h3>
        </div>

        {/* Option cards */}
        <div style={{ display: 'flex', gap: 14, marginBottom: 18 }}>
          {options.map((option, i) => (
            <motion.button
              key={i}
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              onClick={option.action}
              data-testid={`create-option-${i}`}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', gap: 10,
                padding: '18px 12px',
                background: '#F8F9FA', border: '1px solid #F0F1F3',
                borderRadius: 14, cursor: 'pointer', flex: 1,
                transition: 'background 0.15s, border-color 0.15s',
              }}
            >
              <div style={{
                width: 56, height: 56, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: option.gradient,
                fontSize: 26, color: '#fff', fontWeight: 300,
              }}>
                {option.icon}
              </div>
              <span style={{
                fontSize: 13, fontWeight: 600, color: '#2C3E50',
                textAlign: 'center', lineHeight: 1.2,
              }}>
                {option.title}
              </span>
            </motion.button>
          ))}
        </div>

        {/* Cancel */}
        <button onClick={onClose} data-testid="create-modal-cancel"
          style={{
            width: '100%', padding: '12px',
            background: '#F1F3F5', border: 'none', borderRadius: 10,
            fontSize: 14, fontWeight: 600, color: '#6C757D',
            cursor: 'pointer', transition: 'background 0.15s',
          }}
          onMouseEnter={(e) => e.target.style.background = '#E9ECEF'}
          onMouseLeave={(e) => e.target.style.background = '#F1F3F5'}
        >
          Cancel
        </button>
      </motion.div>
    </motion.div>
  );
};

export default CreateModal;
